interface Params {
  enableDurationSearch: boolean
  offer: App.Offer | App.OfferSummary
  duration: number | undefined
}

export function getCheapestPackageForDuration({
  enableDurationSearch,
  offer,
  duration,
}: Params): App.Package | null {
  if (!enableDurationSearch || duration === undefined) {
    return offer.lowestPricePackage ?? null
  }

  if (!Number.isFinite(duration)) {
    return null
  }
  const pkg = (offer.packages || []).reduce<App.Package | null>((currentCheapestPackage, offerPackage) => {
    const validPrice = (offerPackage.price > 0)
    if (!validPrice) {
      return currentCheapestPackage
    }
    if (offerPackage.duration === duration) {
      if (!currentCheapestPackage || offerPackage.price < currentCheapestPackage.price) {
        return offerPackage
      }
    }
    return currentCheapestPackage
  }, null)

  return pkg
}
